import * as Utils from './utils';
import $ from 'jquery';
import validate from 'jquery-validation';
import './jquery-validate-extra-rules';

const filterTrigger = document.querySelectorAll('.js-opportunities-trigger'),
    body = document.querySelector('body');

let map = null,
    mapMarkers = [],
    mapBounds,
    mapInfoWindow,
    stateObj = { time: Date.now() };

// Filters trigger
if (filterTrigger.length) {
    filterTrigger.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            body.classList.toggle('show-filter-menu');
        });
    });
}

// Back Link
if (document.querySelector('.js-opportunities-back-link')) {
    // Only use history back if referrer was from this domain
    if (document.referrer.match(/wec/gi) && document.referrer.match(/mission-resources/gi)) {
        document.querySelector('.js-opportunities-back-link').addEventListener('click', e => {
            e.preventDefault();
            window.history.back();
        });
    }
}

// Application Form
if (document.querySelector('.js-opportunities-application-form')) {
    // Reveal application form
    document.querySelector('.js-opportunity-apply').addEventListener('click', e => {
        e.preventDefault();

        // Utils.slideDown(document.querySelector('.js-opportunities-application'), 500);

        // Scroll to application form
        Utils.autoScrollToTarget('.js-opportunities-application', -100);
    });

    processApplication();
}

// Search Form
if (document.querySelector('.js-opportunities-search')) {
    document.querySelector('.js-opportunities-search').addEventListener('submit', e => {
        // Prevent normal submission
        e.preventDefault();

        // Gather the contents of the keywords field and country select
        var form = document.querySelector('.js-opportunities-search'),
            keywords = form.querySelector('input[name=keywords]').value,
            country = form.querySelector('select[name=country]').value,
            searchUrl = '/mission-resources/opportunities';

        // Build URL to load
        if (keywords.length) {
            searchUrl += '/keywords/' + keywords.replace(' ', '+').toLowerCase();
        }

        if (country.length) {
            searchUrl += '/country/' + country.replace(' ', '+').toLowerCase();
        }

        // Load URL
        window.location.assign(searchUrl);
    });
}

// Filter Form
if (document.querySelector('.js-opportunities-filter-form')) {
    document.querySelector('.js-opportunities-filter-form').addEventListener('submit', e => {
        // Prevent normal submission
        e.preventDefault();

        // Gather the category and continent
        var form = document.querySelector('.js-opportunities-filter-form'),
            type = form.querySelector('select[name=type]').value,
            continent = form.querySelector('select[name=continent]').value,
            searchUrl = '/mission-resources/opportunities';

        // Build URL to load
        if (type.length) {
            type = type.replace(/[^\S]/g, '-');
            searchUrl +=
                '/type/' +
                type
                    .replace(/[^a-zA-Z0-9-_]/g, '')
                    .replace(/(-)(?=\1)/g, '')
                    .toLowerCase();
        }

        if (continent.length) {
            searchUrl += '/continent/' + continent.replace(' ', '-').toLowerCase();
        }

        // Load URL
        window.location.assign(searchUrl);
    });
}

if (document.querySelector('.js-opportunities-map')) {
    initMap();
}

function processApplication() {
    $('.js-opportunities-application-form').validate({
        rules: {
            first_name: {
                required: true,
                minlength: 2,
                lettersonly: true,
            },
            surname: {
                required: true,
                minlength: 2,
                lettersonly: true,
            },
            email_address: {
                required: true,
                email: true,
            },
            tel_number: {
                required: true,
                digitsandspaces: true,
                minlength: 8,
                maxlength: 18,
            },
            dob: {
                required: true,
                dateformat: true,
            },
            nationality: {
                required: true,
                lettersonly: true,
            },
            country_of_residence: {
                required: true,
            },
            consent: {
                required: true,
            },
        },
        messages: {
            first_name: {
                required: 'Please provide your first name',
                minlength: 'Please provide your full first name',
                lettersonly: 'Please use only letters, spaces and hyphens',
            },
            surname: {
                required: 'Please provide your last name',
                minlength: 'Please provide your full last name',
                lettersonly: 'Please use only letters, spaces and hyphens',
            },
            email_address: {
                required: 'Please provide your email address',
                email: 'Please provide a valid email address',
            },
            tel_number: {
                required: 'Please enter a contact telephone number',
                digitsandspaces: 'Please enter only numbers and spaces',
                minlength: 'Please enter a valid telephone number (8-18 characters)',
                maxlength: 'Please enter a valid telephone number (8-18 characters)',
            },
            dob: {
                required: 'Please enter your date of birth',
                dateformat: 'Please enter a date in the format dd/mm/yyyy',
            },
            nationality: {
                required: 'Please enter your nationality',
                lettersonly: 'Please use only letters, spaces and hyphens',
            },
            country_of_residence: {
                required: 'Please select your country of residence',
            },
            consent: {
                required:
                    'You must agree to our use of your data as outlined in our Privacy Policy',
            },
        },
        errorPlacement: function(error, element) {
            if (element.is('[type=checkbox]')) {
                // Check for a group container
                const $checkboxGroupContainer = element.closest('.js-checkbox-container');

                if ($checkboxGroupContainer.length) {
                    return $checkboxGroupContainer.append(error);
                }
            } else if (element.attr('name') === 'country_of_residence') {
                return error.insertAfter(element.parent());
            }

            return error.insertAfter(element);
        },
        submitHandler: function(form) {
            const formData = new FormData(form);

            fetch(form.action, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
                .then(response => response.text())
                .then(data => {
                    document.querySelector('.js-application-response').innerHTML = data;
                    document.querySelector('.js-application-response').classList.add('show');
                });
        },
    });
}

function initMap() {
    let location = { lat: 0, lng: 0 };

    mapBounds = new google.maps.LatLngBounds();

    mapInfoWindow = new google.maps.InfoWindow({
        maxWidth: 300,
        content: 'placeholder',
    });

    map = new google.maps.Map(document.getElementById('map'), {
        zoom: 2,
        minZoom: 2,
        center: location,
        scrollwheel: false,
    });

    // Filter Form
    if (document.querySelector('.js-opportunities-map-filter-form')) {
        document
            .querySelector('.js-opportunities-map-filter-form')
            .addEventListener('submit', e => {
                // Prevent normal submission
                e.preventDefault();

                // Gather the category and continent
                var form = document.querySelector('.js-opportunities-map-filter-form'),
                    typeSelect = form.querySelector('select[name=type]'),
                    continentSelect = form.querySelector('select[name=continent]'),
                    type = '',
                    continent = '',
                    filterUrl = '/mission-resources/opportunities/map';

                // Filter the mapMarkers array to those items
                // with type and continent as specified
                type = typeSelect.value;
                continent = continentSelect.value;

                for (var i = 0; i < mapMarkers.length; i++) {
                    var marker = mapMarkers[i];

                    if (type.length && continent.length) {
                        if (marker.type === type && marker.continent === continent) {
                            marker.marker.setVisible(true);
                        } else {
                            marker.marker.setVisible(false);
                        }
                    } else if (type.length && continent.length === 0) {
                        if (marker.type === type) {
                            marker.marker.setVisible(true);
                        } else {
                            marker.marker.setVisible(false);
                        }
                    } else if (type.length === 0 && continent.length) {
                        if (marker.continent === continent) {
                            marker.marker.setVisible(true);
                        } else {
                            marker.marker.setVisible(false);
                        }
                    } else {
                        marker.marker.setVisible(true);
                    }
                }

                // Build URL to push
                if (type.length) {
                    type = type.replace(/[^\S]/g, '-');
                    filterUrl +=
                        '/type/' +
                        type
                            .replace(/[^a-zA-Z0-9-_]/g, '')
                            .replace(/(-)(?=\1)/g, '')
                            .toLowerCase();
                }

                if (continent.length) {
                    filterUrl += '/continent/' + continent.replace(' ', '-').toLowerCase();
                }

                // Push concatenated URL
                history.pushState(stateObj, 'Filtered Opportunities', filterUrl);
            });
    }

    // Request the marker data and populate the map
    loadMapData();
}

function loadMapData() {
    // Always load all the markers, because any filtering happens by setting visibility attr per marker
    fetch('/mission-resources/opportunities/map-data', {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then(response => response.json())
        .then(data => {
            // Loop over JSON response and build marker and info window
            addMapMarker(data.opportunities);
        });
}

function addMapMarker(opportunities) {
    if (opportunities.length > 0) {
        var item = opportunities.pop();

        // Only create the marker if latitude and longitude are numeric
        if (item.latitude !== null && item.longitude !== null) {
            var marker = new google.maps.Marker({
                    position: { lat: item.latitude, lng: item.longitude },
                    map: map,
                    title: item.title,
                }),
                infoContent =
                    '<div class="opportunities--map-info-window"><h2>' +
                    item.title +
                    '</h2>' +
                    '<p>' +
                    item.description +
                    '</p>' +
                    '<p><a href="/mission-resources/opportunities/position/' +
                    item.slug +
                    '" title="Read more about this opportunity">Read more</a></p></div>';

            marker.addListener('click', function() {
                mapInfoWindow.setContent(infoContent);

                mapInfoWindow.open(map, marker);
            });

            // Add marker to global markers array
            mapMarkers.push({
                marker: marker,
                type: item.type,
                continent: item.continent,
            });

            // Extend the maps bounds to include this markers position
            mapBounds.extend(marker.getPosition());
        }

        // Add the next marker
        setTimeout(function() {
            addMapMarker(opportunities);
        }, 0);
    } else {
        if (mapMarkers.length > 0) {
            handleUrlFilters();

            // Once we've setup all the markers we need to position and zoom the map
            map.fitBounds(mapBounds);
        }
    }
}

function handleUrlFilters() {
    var urlComponents = window.location.pathname.split('/'),
        localIndex = 0,
        urlType = '',
        urlContinent = '',
        form = document.querySelector('.js-opportunities-map-filter-form'),
        typeSelect = form.querySelector('select[name=type]'),
        continentSelect = form.querySelector('select[name=continent]');

    if (urlComponents[3 + localIndex] === 'type') {
        // Set Type select field to option matching URL component
        urlType = urlComponents[4 + localIndex].split('-');

        var typeComponentCount = urlType.length;

        typeSelect.querySelectorAll('option').forEach(opt => {
            var i = 0,
                optionVal = opt.value.toLowerCase(),
                setOption = true;

            for (i; i < typeComponentCount; i++) {
                // If type url component not in the options value don't select this option
                if (optionVal.indexOf(urlType[i]) < 0) {
                    setOption = false;
                }
            }

            if (setOption) {
                opt.selected = true;
            }
        });
    }

    if (
        urlComponents[3 + localIndex] === 'continent' ||
        urlComponents[5 + localIndex] === 'continent'
    ) {
        // Set Continent select field to option matching URL component
        if (urlComponents[3 + localIndex] === 'continent') {
            urlContinent = urlComponents[4 + localIndex].split('-');
        } else {
            urlContinent = urlComponents[6 + localIndex].split('-');
        }

        var continentComponentCount = urlContinent.length;

        continentSelect.querySelector('option').forEach(opt => {
            var i = 0,
                optionVal = opt.value.toLowerCase(),
                setOption = true;

            for (i; i < continentComponentCount; i++) {
                // If type url component not in the options value don't select this option
                if (optionVal.indexOf(urlContinent[i]) < 0) {
                    setOption = false;
                }
            }

            if (setOption) {
                opt.selected = true;
            }
        });
    }

    // Account for any filters within the URL by forcing a submission of the filter form
    // if ($._data($('.js-opportunities-map-filter-form').get(0), 'events').submit) {
    // form.submit();
    // }
    if (typeof window.CustomEvent === 'function') {
        let customSubmitEvt = new CustomEvent('submit', { bubbles: true, cancelable: true });

        form.dispatchEvent(customSubmitEvt);
    }
}
